import { numberToPrettyString } from '@cian/utils';

import { NBSP } from 'shared/constants/text';

import { noBreak } from './noBreak';

/** Цена в рублях: `20 400 ₽` (`prettyPriceString` монолита) */
export const formatRubles = (value: number): string => `${noBreak(numberToPrettyString(value))}${NBSP}₽`;
